module.exports = __webpack_public_path__ + "static/media/light_SocialsInOne_logo.a52db4d5.png";